import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Button,
  Grid,
  Box,
  Table,
  TableRow,
  TableBody,
  useTheme,
  styled,
  TableCell,
  TableHead,
} from "@mui/material";
import { formatValue, formatValueDecimal } from "../../../component/Methods";

const Tablecell = styled(TableCell)(({ theme }) => ({
  fontSize: "12px",
  padding: "1px 2px 1px 5px",
}));
const PositionsSummaryPopUp = (props) => {
  const theme = useTheme();
  const { title, openSummaryPopup, setopenSummaryPopup, totals, tablehead } =
    props;

  const handleClose = () => {
    setopenSummaryPopup(false);
  };

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      onClose={handleClose}
      open={openSummaryPopup}
      sx={{
        "& .css-1t1j96h-MuiPaper-root-MuiDialog-paper": {
          minWidth: "300px",
          marginLeft: "200px",
        },
      }}
    >
      <DialogTitle>
        <Typography
          variant="h6"
          component="div"
          align="left"
          style={{ flexGrow: 1, fontSize: "20px" }}
        >
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12 }}>
            <Box
              sx={{
                border: `1px solid ${theme.palette.lightGrey.tableHeader}`,
                borderRadius: "4px",
              }}
            >
            <Table size="small">
              <TableHead>
                <TableRow
                  sx={{ backgroundColor: theme.palette.lightGrey.backgroundBody }}
                >
                  {tablehead?.map((i) => {
                    return (
                      <Tablecell
                        key={i}
                        align="center"
                        sx={{
                          borderRight: `1px solid ${theme.palette.lightGrey.tableHeader}`,
                          color: theme.palette.lightGrey.textColor,
                          fontSize: theme.typography.bodyText12.fontSize,
                          fontWeight: theme.typography.bodyText12.fontWeight,
                          background: theme.palette.lightGrey.backgroundBody,
                        }}
                      >
                        {i}
                      </Tablecell>
                    );
                  })}
                </TableRow>
              </TableHead>

              <TableBody>
                {totals.map((row) => (
                  <TableRow
                    key={row.name}
                    sx={{
                      "&:hover": {
                        background: theme.palette.grey[200],
                        cursor: "pointer",
                      },
                    }}
                  >
                    <Tablecell
                      align="left"
                      sx={{
                        color: theme.palette.lightGrey.textColor,
                        fontSize: theme.typography.bodyText12.fontSize,
                        fontWeight: theme.typography.bodyText12.fontWeight,
                        borderRight: `1px solid ${theme.palette.lightGrey.tableHeader}`,
                        background: theme.palette.lightGrey.backgroundBody,
                      }}
                    >
                      {row.name}
                    </Tablecell>

                    <Tablecell
                      align="right"
                      style={{
                        borderRight: `1px solid ${theme.palette.lightGrey.tableHeader}`,
                        background: theme.palette.grey[100],
                      }}
                    >
                      {row.totalsAUM != null && !isNaN(row.totalsAUM) && isFinite(row.totalsAUM) ? (
                        row.totalsAUM > 0 ? (
                          <>{row.totalsAUM.toFixed(2)}%&nbsp;</>
                        ) : row.totalsAUM < 0 ? (
                          `(${(row.totalsAUM * -1).toFixed(2)}%)`
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}
                    </Tablecell>
                    <Tablecell
                      align="right"
                      style={{
                        borderRight: `1px solid ${theme.palette.lightGrey.tableHeader}`,
                        background: theme.palette.grey[100],
                        color: row.totalsPl != null && !isNaN(row.totalsPl) && isFinite(row.totalsPl) && row.totalsPl > 0 ? "green" : "red",
                      }}
                    >
                      {row.totalsPl != null && !isNaN(row.totalsPl) && isFinite(row.totalsPl) ? (
                        row.totalsPl > 0 ? (
                          <>{formatValue(row?.totalsPl, true)}&nbsp;</>
                        ) : row.totalsPl < 0 ? (
                          `(${formatValue(row?.totalsPl * -1, true)})`
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}
                    </Tablecell>
                    <Tablecell
                      align="right"
                      style={{
                        borderRight: `1px solid ${theme.palette.lightGrey.tableHeader}`,
                        background: theme.palette.grey[100],
                        color: row.totalsPcm != null && !isNaN(row.totalsPcm) && isFinite(row.totalsPcm) && row.totalsPcm > 0 ? "green" : "red",
                      }}
                    >
                      {row.totalsPcm != null && !isNaN(row.totalsPcm) && isFinite(row.totalsPcm) ? (
                        row.totalsPcm > 0 ? (
                          <>{row.totalsPcm.toFixed(2)}%&nbsp;</>
                        ) : row.totalsPcm < 0 ? (
                          `(${(row.totalsPcm * -1).toFixed(2)}%)`
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}
                    </Tablecell>
                    <Tablecell
                      align="right"
                      style={{
                        borderRight: `1px solid ${theme.palette.lightGrey.tableHeader}`,
                        background: theme.palette.grey[100],
                        color: row?.totalSignals != null && !isNaN(row?.totalSignals) && isFinite(row?.totalSignals) && row?.totalSignals > 0 ? "green" : "red",
                      }}
                    >
                      {row.totalSignals != null && !isNaN(row.totalSignals) && isFinite(row.totalSignals) ? (
                        row.totalSignals > 0 ? (
                          <>{formatValueDecimal(row?.totalSignals)}&nbsp;</>
                        ) : row.totalSignals < 0 ? (
                          `(${formatValueDecimal(row?.totalSignals * -1)})`
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}
                    </Tablecell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            </Box>
          </Grid>

        <Grid
          size={{ xs: 12 }}
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "5px",
          }}
        >
          <Button
            variant="contained"
            sx={{
              width: "10%",
              background: "#B2BEB5",
              color: "#000",
              "&:hover": { background: "#808080" },
            }}
            onClick={() => {
              setopenSummaryPopup(false);
            }}
          >
            CLOSE
          </Button>
        </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default PositionsSummaryPopUp;